import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef, EventEmitter,Input } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';
import { orderBy, get, minBy } from 'lodash';
import { map, share, shareReplay, tap } from 'rxjs/operators';
import { ReplyItem, Option } from '../../../../classes';
import { RepliesService } from '../../../../services';
import { ChartsService } from '../../charts.service';
import { PartialOption } from '../../charts.types';

@Component({
  selector: 'app-replies-per-option',
  templateUrl: './replies-per-option.component.html',
  styleUrls: ['./replies-per-option.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush,

})
export class RepliesPerOptionComponent implements OnInit {
  action: EventEmitter<any> = new EventEmitter();  
  @Input()replies :Observable<ReplyItem[]>;
  @Input()option :PartialOption;
  list:ReplyItem[];
  ordered:Observable<ReplyItem[]>;

  constructor(
    private modalRef : BsModalRef,
    private repliesService:RepliesService,
    private chartService:ChartsService,
    private cdRef:ChangeDetectorRef,
  ) { 
  }
  ngOnInit() {
    this.ordered = this.replies.pipe(
      map(list=>{
        return orderBy(
          list, 
          li=>this.getCheckTimestamp(li)
        ) 
      }),
      tap(list=>this.list = list),
      shareReplay(1),
    )
    this.ordered.subscribe(()=>this.cdRef.detectChanges())
  }
  ok (data:any = true) {
    this.modalRef.hide(); 
    this.action.emit(data);
  }
  cancel () {
    this.modalRef.hide(); 
    this.action.emit(false);
  }  
  getCheckTimestamp (li:ReplyItem):number {
    if (this.option.quota) return get(li, ['snapshot', this.option.question.id, this.option.id, 'timestamp']);
    else {
      const question_id = get(this.option ,['question', 'id']);
      const option_id = get(this.option, ['id']);
      if (question_id && option_id) {
        const list = this.repliesService.raw.filter(r=>r.as === li.as && get(r, ['snapshot', this.option.question.id, this.option.id]));
        return minBy(list, 'timestamp').timestamp;
      } else {
        return li.timestamp;
      }
    }  
  }
  download() {
    this.chartService.downloadExcel(this.list, [this.option]);

  }

}
